import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { environment } from '@root/environments/environment';
import { Observable } from 'rxjs';

export function subscriptionKeyInterceptor(
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> {
  if (request?.url?.includes('/tell/') || request?.url?.includes('/ask/')) {
    request = request.clone({
      setHeaders: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Ocp-Apim-Subscription-Key': environment.apimSubscriptionKey,
      },
    });
  }
  return next(request);
}
